import React, { useEffect } from 'react';

export default function SsoCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const userId = params.get('userId');
    const email = params.get('email');
    const firstName = params.get('firstName');
    const lastName = params.get('lastName');
    const role = params.get('role');
    const organizationId = params.get('organizationId');

    if (!token) {
      window.location.href = '/login?error=sso_failed';
      return;
    }

    // Refresh token is set as httpOnly cookie by the server — store only non-sensitive session data
    const userData = {
      id: userId,
      email,
      firstName,
      lastName,
      role,
      organizationId,
      token
    };

    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('sessionStart', Date.now().toString());
    localStorage.setItem('lastActivity', Date.now().toString());

    // Full page reload so AuthContext picks up the new session
    window.location.href = '/';
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <p>Signing you in...</p>
    </div>
  );
}